import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { ShipClassService } from 'src/app/Services/shipclass.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';
import * as moment from 'moment';
import { ItiCodesService } from 'src/app/Services/iti-codes.service';
import { CruisepciService } from 'src/app/Services/cruisepci.service';
import { WeatherService } from 'src/app/Services/weather.service';
import { WeatherIconService } from 'src/app/Services/weathericon.service';
import { TripContextService } from 'src/app/Services/trip-context.service';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type iticodeInfo = {
  evtCode: string; 
  llcitiCode: string; 
  llcltcUid: number; 
  llcuid: number;
  ltcName: string; 
  ltcUid: number;
  itiBegDate: Date;
  locallooptoday: boolean; 
}; 

@Component({
  selector: 'app-my-day',
  templateUrl: './my-day.component.html',
  styleUrls: ['./my-day.component.css'],
})
export class MyDayComponent {
  @Input() inputdate: string | undefined;
  
  @Input() portcity!: string;
  WeatherData?: any;
  WeatherIconData?: any;

  CurrentDate: any;
  itiBegDate: any;

  userdata?: UserData;

  currentdate: string | undefined;
  CurrentTime: string | undefined;
  pagemask: boolean | undefined; 

  validsession: boolean | undefined;
  serdata?: UserData;
  shpId: number | undefined;
  shipname: string | undefined;
  shipClass: string | undefined;
  shipclassdata: any;
  lastday: boolean = false;
  LoginData: any;
  employeeData?: EmployeeData;

  evtCode: string | undefined;

  iticodedata: any; 
  iticodes: iticodeInfo[] = [];

  eventCode: string | undefined;
  CruisePCIInfo: any;
  CruisePCIData: any;

  constructor(
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private ShipClassService: ShipClassService,
    private EmployeeLoginService: EmployeeloginService,
    private ItiCodesService: ItiCodesService,
    private CruisePCIService: CruisepciService,
    private WeatherService: WeatherService,
    private WeatherIconService: WeatherIconService,
    private tripContextService: TripContextService,
  ) {
  }

  ngOnInit(): void {
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.evtCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
        this.lastday = moment(this.userdata?.pckgEnd!).isSame(moment(), 'day');

        this.getShipClass();
      } else {
        this.router.navigate(['/login']);
      }
    }
    this.CurrentDate = moment().startOf('day').toDate();
    
    this.pagemask = this.tripContextService.resolve(this.userdata).pagemask;
    if (this.pagemask === true) {
      this.getCruisePCIData();
    }
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
        this.shipname = this.userdata?.ShipName!;
        this.getShipClass();
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }

  getShipClass() {
    this.shipclassdata = this.ShipClassService.getShipClass(
      this.shpId
    ).subscribe((shipclassdata) => this.setShipClass(shipclassdata));
  }

  setShipClass(resdata: any) {
    this.shipclassdata = resdata;
    if (this.shipclassdata.GetShipClass.Result.Status == 'A') {
      this.shipname = this.userdata?.ShipName!;
      if (
        this.shipclassdata.GetShipClass.ShipClassList[0].ClassName ==
        'COASTAL CLASS CRUISES'
      )
        this.shipClass = 'Coastal';
      else this.shipClass = 'River';
    } else this.shipClass = 'River';
    this.getItiCodes();
  }

  getItiCodes() {
    this.iticodedata = this.ItiCodesService.getItiCodes(
      this.evtCode
    ).subscribe((iticodedata) => this.setItiCodes(iticodedata));
  }
  setItiCodes(resdata: any) {
    this.iticodedata = resdata; 
    if (this.iticodedata.GetItiCodes.Result.Status == 'A') {
      this.iticodes = this.iticodedata.GetItiCodes.ItiCodesList.filter(
        
        // if the ltcName ("Newport Local Loop: Newport, RI | AM") has a space then a | in it
        (s: { ltcName: string }) =>
          (s.ltcName.includes(' |')
        )); 
        //  remove everything after the space and | 
        this.iticodes.forEach((currentValue, index) => {
          
        if (currentValue.ltcName.includes(' |'))
          currentValue.ltcName = currentValue.ltcName.split(' |')[0]
        
        currentValue.itiBegDate = moment(currentValue?.itiBegDate).startOf('day').toDate();

        if (moment(currentValue?.itiBegDate).isSame(this.CurrentDate,'day'))
           currentValue.locallooptoday = true;
        });

      }
    }

  getCruisePCIData() {
    this.eventCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.CruisePCIData = this.CruisePCIService.GetCruisePCI(
      this.eventCode
    ).subscribe((CruisePCIData) => this.setCruisePCIData(CruisePCIData));
  }
  setCruisePCIData(resdata: any) {
    this.CruisePCIData = resdata;
    if (this.CruisePCIData.GetCruisePCI.Result.Status == 'A') {
      this.CruisePCIInfo = this.CruisePCIData.GetCruisePCI.CruisePCIList;

      this.CruisePCIInfo.forEach((currentValue: { itiComments: string; }, index: any) => {

         if (currentValue.itiComments.includes('|'))
          currentValue.itiComments = currentValue.itiComments.replace('|', ' \n')

      });

      this.portcity = this.CruisePCIInfo[0].poc

      if (this.portcity != '') {
        this.getWeatherForecast(this.portcity, moment(this.CurrentDate).format('YYYY-MM-DD'));
      } 
    }
  }

  getWeatherForecast(city: string, forecastdate: string) {
    this.WeatherService.getWeatherForecastDataAndIcon(
      city,
      forecastdate
    ).subscribe(({ weather, icon }) => {
      this.setWeatherData(weather);
      this.setWeatherIconData(icon);
    });
  }

  setWeatherData(data: any) {
    this.WeatherData = data;
  }
  setWeatherIconData(data: any) {
    this.WeatherIconData = data;
    if (this.WeatherIconData.GetWeatherIcons.Result.Status == 'A') {
      this.WeatherIconData = this.WeatherIconData.GetWeatherIcons.WeatherIcon;
    }
  }

}
